<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isBranchManager()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <v-select
                                            v-model="params.branch"
                                            class="form-control"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Payment Mode:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.payment_mode"
                                        >
                                            <option
                                                v-for="payment_mode in payment_modes"
                                                :value="
                                                    payment_mode.payment_name
                                                "
                                            >
                                                {{ payment_mode.payment_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div
                                    class="col-sm-4"
                                    v-if="params.payment_mode == 'Finance'"
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Finance Mode:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.finance_mode"
                                        >
                                            <option
                                                v-for="finance_mode in finance_modes"
                                                :value="
                                                    finance_mode.finance_name
                                                "
                                            >
                                                {{ finance_mode.finance_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Status:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.status"
                                        >
                                            <option value="FLAGGED">
                                                FLAGGED
                                            </option>
                                            <option value="CLEAR">CLEAR</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.from_date"
                                            placeholder="From date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.to_date"
                                            placeholder="To date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >CP ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter cp no."
                                            v-model="params.cp_id"
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Gatepass ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter gatepass no."
                                            v-model="params.gatepass_id"
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Receipt ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter receipt no."
                                            v-model="params.receipt_id"
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Transaction No:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter draft order no."
                                            v-model="params.transaction_no"
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Mobile No:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter mobile no."
                                            v-model="params.mobile"
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getData(
                                                    '/api/getAllCollectedPayments'
                                                )
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row" align="center">
                            <div class="col-lg-6 col-12">
                                <!-- small box -->
                                <div class="small-box bg-secondary">
                                    <div class="inner">
                                        <h4>
                                            {{ total_collected | dotNumbers }}
                                        </h4>
                                        <p>Total Amount Collected</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-person-add"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-12">
                                <!-- small box -->
                                <div class="small-box bg-secondary">
                                    <div class="inner">
                                        <h4>{{ pagination.total }}</h4>
                                        <p>Total Entries</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-person-add"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-9">
                        <h5>DATASHEET V1.0</h5>
                        <h5>Total Entries: {{ pagination.total }}</h5>
                    </div>
                    <div class="col-md-3">
                        <pagination
                            :pagination="pagination"
                            @prev="getData(pagination.prevPageUrl)"
                            @next="getData(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
                <div class="card card-primay card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th scope="col">CP_ID</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Gatepass</th>
                                    <th scope="col">Receipt</th>
                                    <th scope="col">Payment Mode</th>
                                    <th scope="col">Finance mode</th>
                                    <th scope="col">Transaction#</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">DownPayment</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Manage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(j, index) in data" :key="j.id">
                                    <td>{{ j.id }}</td>
                                    <td>{{ j.created_at | timeStamp }}</td>
                                    <td>{{ j.branch_code }}</td>
                                    <td>{{ j.gatepass_id }}</td>
                                    <td>{{ j.receipt_id }}</td>
                                    <td>{{ j.payment_mode }}</td>
                                    <td>{{ j.finance_mode }}</td>
                                    <td>{{ j.transaction_id }}</td>
                                    <td>{{ j.amount_collected }}</td>
                                    <td>{{ j.downpayment }}</td>
                                    <td
                                        v-if="j.status == 'CLEAR'"
                                        class="badge-success"
                                    >
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                :id="'ja' + index"
                                                checked
                                                @input="changeStatus(j.id)"
                                            />
                                            <label
                                                class="custom-control-label"
                                                :for="'ja' + index"
                                                >C</label
                                            >
                                        </div>
                                    </td>
                                    <td
                                        v-if="j.status == 'FLAGGED'"
                                        class="badge-warning"
                                    >
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                :id="'ji' + index"
                                                @input="changeStatus(j.id)"
                                            />
                                            <label
                                                class="custom-control-label"
                                                :for="'ji' + index"
                                                >F</label
                                            >
                                        </div>
                                    </td>
                                    <td>
                                        <!--										<button class="btn btn-primary" @click="viewRequest(j.id)">View</button>-->
                                        <button
                                            class="btn btn-secondary"
                                            @click="viewMore(j)"
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getData(pagination.prevPageUrl)"
                            @next="getData(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="viewModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Full Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <p>
                                        Receipt: {{ full_details.receipt_id }}
                                    </p>
                                    <p>
                                        Gatepass: {{ full_details.gatepass_id }}
                                    </p>
                                    <p>
                                        Draft Order:
                                        {{ full_details.draft_order_id }}
                                    </p>
                                    <p>Order: {{ full_details.order_id }}</p>
                                    <p>
                                        Payment Mode:
                                        {{ full_details.payment_mode }}
                                    </p>
                                    <p>
                                        Finance mode:
                                        {{ full_details.finance_mode }}
                                    </p>
                                    <p>
                                        Amount Collected:
                                        {{ full_details.amount_collected }}
                                    </p>
                                    <p>
                                        Downpayment:
                                        {{ full_details.downpayment }}
                                    </p>
                                    <p>
                                        Account Code:
                                        {{ full_details.account_code }}
                                    </p>
                                    <p>
                                        Finance completion Date:
                                        {{
                                            full_details.finance_completion_date
                                        }}
                                    </p>
                                    <p>
                                        Installments:
                                        {{ full_details.installments }}
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <p>
                                        Transfer Date:
                                        {{ full_details.transfer_date }}
                                    </p>
                                    <p>
                                        Mobile: {{ full_details.mobile_number }}
                                    </p>
                                    <p>
                                        Transaction:
                                        {{ full_details.transaction_id }}
                                    </p>
                                    <p>
                                        Voucher: {{ full_details.voucher_no }}
                                    </p>
                                    <p>
                                        Card Holder Name:
                                        {{ full_details.card_holder_name }}
                                    </p>
                                    <p>
                                        Card Validity:
                                        {{ full_details.card_validity }}
                                    </p>
                                    <p>Card no: {{ full_details.card_no }}</p>
                                    <p>
                                        Card Type: {{ full_details.card_type }}
                                    </p>
                                    <p>
                                        Cheque no:
                                        {{ full_details.cheque_number }}
                                    </p>
                                    <p>
                                        Cheque Branch:
                                        {{ full_details.cheque_branch }}
                                    </p>
                                    <p>
                                        Cheque Account No:
                                        {{ full_details.cheque_account_no }}
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                Created By:
                                {{ full_creator_details.user_detail }}
                                <br />
                                Created On:
                                {{ full_details.created_at | timeStamp }}
                            </div>
                            <div
                                class="row"
                                v-if="full_details.updater != null"
                            >
                                Updated By:
                                {{ full_updator_details.user_detail }}
                                <br />
                                Updated On:
                                {{ full_details.updated_at | timeStamp }}
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isBranchManager()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { pagination: Pagination },

    created() {
        if (typeof this.$route.params.receipt !== "undefined") {
            this.params.receipt_id = this.$route.params.receipt;
        }
        // else{
        //     this.fromdate= new Date().toISOString().slice(0, 10);
        //     this.todate= new Date().toISOString().slice(0, 10);
        // }
        this.getBranches();
        this.getPMS();
        this.getFMS();
        this.getData();
    },

    data() {
        return {
            data: [],
            results: "30",
            branches: [],
            payment_modes: [],
            finance_modes: [],
            total_collected: "0",
            full_details: [],
            full_creator_details: [],
            full_updator_details: [],
            params: new Form({
                branch: null,
                from_date: null,
                to_date: null,
                payment_mode: null,
                finance_mode: null,
                transaction_no: null,
                gatepass_id: null,
                receipt_id: null,
                cp_id: null,
                status: null,
                mobile: null,
            }),
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
        };
    },

    methods: {
        getData(url = "/api/getAllCollectedPayments") {
            axios
                .post(url, { results: this.results, params: this.params })
                .then((response) => {
                    this.data = response.data.data.data;
                    this.total_collected = response.data.sum;
                    this.configPagination(response.data.data);
                });
        },

        getPMS() {
            axios.post("/api/getSAPPaymentModes").then((response) => {
                this.payment_modes = response.data;
            });
        },

        getFMS() {
            axios.post("/api/getCompanyFinanceModes").then((response) => {
                this.finance_modes = response.data;
            });
        },

        reset() {
            this.params.reset();
            this.getData();
        },

        getBranches() {
            if (this.usertype == "zonal-manager") {
                axios.post("/api/getZonalManagerBranches").then((response) => {
                    this.branches = response.data;
                });
            } else {
                axios.post("/api/getSAPBranches").then((response) => {
                    this.branches = response.data;
                });
            }
        },

        viewMore(info) {
            this.full_details = info;
            this.full_creator_details = info.user;
            this.full_updator_details = info.updater;
            $("#viewModal").modal("show");
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        viewRequest(id) {
            this.$router.push("/stock-transfer/print/" + id);
        },

        editRequest(id) {
            this.$router.push("/stock-transfer-details/" + id);
        },

        changeStatus(id) {
            axios
                .post("/api/changeCollectedPaymentStatus", { id: id })
                .then(() => {
                    this.getData(
                        "/api/getAllCollectedPayments" +
                            "?page=" +
                            this.pagination.currentPage
                    );
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },
    },
};
</script>
